import React from "react";
import { CloseIcon, Div, LeftIcon, Text4 } from "components/Base";
import Tabs from "./Tabs";
import { connect } from "react-redux";
import { TAB_IDS } from "../constants";
import { getters } from "../model";
import Details from "./Details";
import Tasks from "./Tasks";
import Sessions from "./Sessions";
import Footer from "./Footer";
import { getAccentColor } from "Portal/NewPortal/PortalHome/selectors";

const decorate = connect(state => ({
  selectedTab: getters.selectedTab(state),
  isEditingDetails: getters.isEditingDetails(state),
  accentColor: getAccentColor(state)
}));

const ViewContact = ({ data = {}, closeView, selectedTab, accentColor }) => {
  return (
    <Div
      width={1}
      display="column.flex-start.stretch"
      style={{ height: "100%" }}
    >
      <Div style={{ height: "100%", overflow: "scroll" }}>
        <Div
          width={1}
          display="row.space-between.center"
          style={{ borderBottom: "1px solid #E7E6EA" }}
          px={5}
          py={3.75}
        >
          <Div display="column.flex-start.flex-start">
            <Div
              display="row.flex-start.center"
              color={accentColor}
              onClick={closeView}
              fw={3}
              fs={2}
              mb={2.5}
              ml="-5px"
            >
              <LeftIcon color={accentColor} size={20} mr={1} />
              <span>Back to Session</span>
            </Div>
            <Text4 bold>{data.name}</Text4>
          </Div>
          <Div onClick={closeView} height={1}>
            <CloseIcon color={"neutral7"} sizeWFS={3} />
          </Div>
        </Div>
        <Tabs />
        {selectedTab === TAB_IDS.DETAILS && <Details />}
        {selectedTab === TAB_IDS.TASKS && <Tasks />}
        {selectedTab === TAB_IDS.SESSIONS && <Sessions />}
      </Div>
      <Footer closeView={closeView} />
    </Div>
  );
};

export default decorate(ViewContact);
